/**
 * Created by Andriyanto.
 * E-Mail Address: 4lenour@gmail.com
 * Date: 20/04/2025
 */

import { elementHelper } from './elementHelper.js';

export const routeHelper = {
    asyncComponentWithLoader: (importFunc) => {
        return () => {
            elementHelper.loader.show('body_loader', window.document.body);
            return importFunc().finally(() => {
                elementHelper.loader.hide('body_loader');
            });
        };
    }
};
